import PropTypes from "prop-types";
import cn from "classnames";

export function Blockquote({ data, themeClasses }) {
  const [quote, attribution] = data;

  return (
    <blockquote
      className={cn(
        "px-6 py-8 rounded-l ml-12",
        themeClasses.textQuote,
        themeClasses.backgroundQuote
      )}
    >
      <p className="text-3xl font-normal font-instrument">
        &quot;{quote}&quot;
      </p>
      <p className="mt-4 font-extrabold capitalize font-neue">{attribution}</p>
    </blockquote>
  );
}

Blockquote.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string).isRequired,
  themeClasses: PropTypes.shape({
    textQuote: PropTypes.string,
    backgroundQuote: PropTypes.string,
  }),
};
